import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import auth from './modules/auth';
import checkout from './modules/checkout';
import basket from './modules/basket';
import favorite from './modules/favorite';
import compare from './modules/compare';
import project from './modules/project';
import orders from './modules/orders';
import course from './modules/course';
import productQuantity from './modules/productQuantity';
import createLogger from 'vuex/dist/logger';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        app, auth, checkout, basket, favorite, compare, productQuantity, project, orders, course
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
});

